import "../../app/globals.css";
import { useRouter } from "next/router";
import React, { useState, useEffect, Suspense, useRef } from "react";
import Header from "@/components/Header/Header";
import Footer from "@/components/Footer/Footer";
import {
  Zap,
  ShoppingCart,
  CircleDollarSign,
  Truck,
  Phone,
  Mail,
  FileText,
} from "lucide-react";
import "./ProductDetail.css";
import ImageGallery from "react-image-gallery";
import { Tooltip } from "@mui/material";
import { Col, Container, Row, Breadcrumb } from "react-bootstrap";
import { Tabs, Input, Tag, List, Card, Modal, Spin, Button } from "antd";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { Flame, Droplet } from "lucide-react";
import { FaRegBookmark } from "react-icons/fa6";
import { FiShare2 } from "react-icons/fi";
import ProductCard from "../ProductCard/ProductCard";
// import MakeOffer from "../MakeOffer/MakeOffer";
import { Icon } from "@iconify/react";
import * as appConstants from "../../utils/constants";
import SaveForLaterButton from "../Buttons/SaveForLaterButton";
import checkFreight from "@/Helper/checkFreight";
import Head from "next/head";
import {
  getTotals,
  handleUpdateQtyCart,
  handleAddCart,
} from "@/lib/store/Slices/CartSlice";
import { Tab, Nav } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "@/lib/store/hooks";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import dynamic from "next/dynamic";

const MakeOffer = dynamic(() => import("../MakeOffer/MakeOffer"), {
  suspense: true,
  ssr: false,
});

export default function ProductDetail({ Item, dataLayer }) {
  const dispatch = useAppDispatch();
  const cart = useAppSelector((state) => state.cart);
  const router = useRouter();
  const [loginData, setLoginData] = useState({});
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleThumbnails, setVisibleThumbnails] = useState(5);
  const [show, setshow] = useState(null);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const { TabPane } = Tabs;
  const [quantityset, setQuantityset] = useState(1);
  const [item, setItem] = useState(Item.item || null);
  const [pinCode, setPinCode] = useState("");
  const [shippingOptions, setShippingOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const thumbnailContainerRef = useRef(null);
  const badgeRef = useRef(null);

  // Fetch the estimated total weight from Item or default to 1 ounce
  const itemWeight = Item?.item?.estimatedTotalWeight || 1; // in ounces
  const isSpecializedFreightTransit = Item?.item?.isSpecializedFreightTransit; // Check if it's specialized freight

  const checkFreightData = {
    selectedQty: quantityset,
    estimatedTotalWeight: itemWeight,
    isSpecializedFreightTransit: isSpecializedFreightTransit,
    widthInches: item?.widthInches,
    heightInches: item?.heightInches,
    lengthInches: item?.lengthInches,
    isLocalPickupOnly: item?.isLocalPickupOnly,
  };

  const isFreight = checkFreight(checkFreightData);

  // Frenzy Alert Badge with Popover instead of Tooltip
  const renderFrenzyAlertBadge = () => {
    const popover = (
      <Popover id="frenzy-alert-popover" className="popover-wide">
        <Popover.Body>
          <strong>
            🩸 Blood’s in the water. The feeding frenzy has begun act now or get
            left behind. <br></br>
          </strong>
          This item is gaining rapid attention. It’s priced aggressively,
          available in limited quantity, and moving quickly. First come, first
          served. Once it’s gone — it’s gone.
        </Popover.Body>
      </Popover>
    );

    return (
      <OverlayTrigger
        trigger={["hover", "focus"]}
        placement="bottom"
        overlay={popover}
        // delay={{ show: 250, hide: 400 }}
      >
        <div
          className="d-inline-flex align-items-center frenzy-badge"
          style={{
            height: "40px",
            padding: "0 12px",
            backgroundColor: "#fff",
            color: "black",
            padding: "5px",
            borderRadius: "4px",
            borderLeft: "4px solid red",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            cursor: "help",
          }}
        >
          <Droplet size={20} color="red" fill="#fb1818" className="me-2" />
          <div className="d-flex flex-column">
            <span
              className="fw-bold"
              style={{ fontSize: "0.875rem", lineHeight: "1.2" }}
            >
              FRENZY ALERT
            </span>
            <span style={{ fontSize: "0.75rem", lineHeight: "1.2" }}>
              Blood in the Water
            </span>
          </div>
        </div>
      </OverlayTrigger>
    );
  };

  const productSpecifications = [
    { label: "Manufacturer", value: item.menufacturer || "N/A" },
    { label: "Model", value: item.model || "N/A" },
    { label: "Serial", value: item.serialNo || "N/A" },
    { label: "Year", value: item.year || "N/A" },
    { label: "HP / AMP / KW / KVA", value: item.hP_AMP_KW_KVA || "N/A" },
    { label: "Amps", value: item.amps || "N/A" },
    { label: "Length (Inches)", value: item.lengthInches || "N/A" },
    { label: "Width (Inches)", value: item.widthInches || "N/A" },
    { label: "Height (Inches)", value: item.heightInches || "N/A" },

    {
      label: "Phase",
      value: item.phase || "N/A",
    },
    {
      label: "Estimated Packaging Weight",
      value: item.estiamtedPackaginWeight || "N/A",
    },
    {
      label: "Estimated Total Weight",
      value: item.estimatedTotalWeight || "N/A",
    },
    { label: "Asset Number", value: item.assetNumber || "N/A" },
  ];

  // Scroll to top when route changes
  useEffect(() => {
    console.log("postion", window.scrollY);
    window.scrollTo(0, 0);
    const handleRouteChange = () => {
      window.scrollTo(0, 0);
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router]);

  useEffect(() => {
    if (dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(dataLayer);
    }
  }, [dataLayer]);

  useEffect(() => {
    const storedLoginData = JSON.parse(localStorage.getItem("login")) || {};
    setLoginData(storedLoginData);
  }, []);

  const buyNow = (selectedItem) => {
    // debugger;
    dispatch(handleAddCart(selectedItem));
    // dispatch(handleUpdateQtyCart(selectedItem));
    dispatch(getTotals());
    fetch("/api/AddToCartNotification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        itemName: selectedItem.description,
        clarityUserId: localStorage.getItem("clarity_user_id") || "N/A",
        name: loginData?.name || "Guest",
        qty: 1,
        userEmail: loginData?.email || "Guest",
        address: loginData?.address || "Guest",
        price: selectedItem.salePrice,
      }),
    });
    if (window.uetq) {
      window.uetq.push({
        ea: "BuyNow", // Event Action
        el: selectedItem.title, // Event Label (e.g., product name)
        ev: selectedItem.salePrice, // Event Value (e.g., product price or revenue)
      });
    }
    router.push("/shopping-cart");
  };

  // Dimensions (if available) from Item
  const dimensions = {
    length: Item?.item?.lengthInches || 5,
    width: Item?.item?.widthInches || 5,
    height: Item?.item?.heightInches || 5,
  };

  const handlePinChange = (e) => setPinCode(e.target.value);

  const toggleDescriptionExpansion = () => {
    setIsDescriptionExpanded((prev) => !prev);
  };

  const isValidZipCode = (code) => /^[0-9]{5}(?:-[0-9]{4})?$/.test(code);

  // Handle image navigation
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => {
      const newIndex =
        prevIndex === (Item?.images?.length - 1 || 0) ? 0 : prevIndex + 1;
      // scrollToThumbnail(newIndex);
      return newIndex;
    });
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => {
      const newIndex =
        prevIndex === 0 ? Item?.images?.length - 1 || 0 : prevIndex - 1;
      // scrollToThumbnail(newIndex);
      return newIndex;
    });
  };

  // const selectImage = (index) => {
  //   setCurrentImageIndex(index);
  //   // scrollToThumbnail(index);
  // };

  const scrollToThumbnail = (index) => {
    const thumbnails = thumbnailContainerRef.current?.children;
    const activeThumbnail = thumbnails ? thumbnails[index] : null;
    if (activeThumbnail) {
      activeThumbnail.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  const selectImage = (index) => {
    setCurrentImageIndex(index);
    scrollToThumbnail(index);
  };

  function transformShippingOptions(result) {
    if (!Array.isArray(result)) return [];

    return result.map((option) => {
      const shippingAmount = option?.shipping_amount?.amount;

      return {
        isInvalid: !shippingAmount || isNaN(shippingAmount),
        serviceType: option?.service_type || "Unknown",
        carrierFriendlyName: option?.carrier_friendly_name || "Unknown Carrier",
        shippingAmount: shippingAmount || null,
        currency: option?.shipping_amount?.currency || "USD",
        estimatedDeliveryDate: option?.estimated_delivery_date || null,
        deliveryDays: option?.delivery_days || null,
      };
    });
  }

  const calculateShipping = async () => {
    if (!pinCode) {
      toast.warning("Please enter a valid zip code.");
      return;
    }

    if (!isValidZipCode(pinCode)) {
      toast.error("Invalid ZIP code format. Please enter a valid US ZIP code.");
      return;
    }
    setLoading(true);
    setShippingOptions([]);
    setIsModalVisible(true); // Open the modal

    try {
      const response = await fetch("/api/calculateShipping", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pinCode,
          weight: itemWeight,
          dimensions,
        }),
      });

      const result = await response.json();
      console.log("Shipping calculation result:", result);
      const options = transformShippingOptions(result.result);
      setShippingOptions(options);

      setShippingOptions(options);
    } catch (error) {
      console.error("Error calculating shipping:", error);
      setShippingOptions([{ serviceType: "Error calculating shipping." }]);
    }
    setLoading(false);
  };

  const conditionLabels = {
    "1. New in Box": "New",
    "1.1 Appears Unused no box": "New",
    "2. Mint (Very good condition for it's age)": "Used",
    "3. Refurbished - See ad for details": "Refurbished",
    "4. Used: Powered up in our shop and appears to be functional": "Used",
    "5. Used: Unit looks good to us": "Used",
    "5.1 Used: Powered up looks fine": "Used",
    "5.2 Used: Reported to be working when removed from service": "Used",
    "5.3 Used: ASIS": "Used",
    "7. Used: UNABLE TO TEST > 440V ASIS": "Used",
    "7.1. Used : UNABLE TO TEST > Gas": "Used",
    "8. Vintage or Antique item": "Used",
    "9.0 Parts or Salvage Only": "Used",
    "9.1 ABSOLUTE LIQUIDATION SALE NO WARRANTY NO RETURN": "Used",
    "9.3. VERY INTERESTING! Don't bid unless you know this equipment": "Used",
  };

  const jsonLdConditionMappings = {
    "1. New in Box": "NewCondition",
    "1.1 Appears Unused no box": "NewCondition",
    "2. Mint (Very good condition for it's age)": "UsedCondition",
    "3. Refurbished - See ad for details": "RefurbishedCondition",
    "4. Used: Powered up in our shop and appears to be functional":
      "UsedCondition",
    "5. Used: Unit looks good to us": "UsedCondition",
    "5.1 Used: Powered up looks fine": "UsedCondition",
    "5.2 Used: Reported to be working when removed from service":
      "UsedCondition",
    "5.3 Used: ASIS": "UsedCondition",
    "7. Used: UNABLE TO TEST > 440V ASIS": "UsedCondition",
    "7.1. Used : UNABLE TO TEST > Gas": "UsedCondition",
    "8. Vintage or Antique item": "UsedCondition",
    "9.0 Parts or Salvage Only": "UsedCondition",
    "9.1 ABSOLUTE LIQUIDATION SALE NO WARRANTY NO RETURN": "UsedCondition",
    "9.3. VERY INTERESTING! Don't bid unless you know this equipment":
      "UsedCondition",
  };

  // Function to get JSON-LD condition label
  const getJsonLdConditionLabel = (condition) => {
    return jsonLdConditionMappings[condition] || "UsedCondition"; // Default value
  };

  const { assetNumber, quantity, guaranteeOrAsis, condition } = item;

  const handleshow = () => {
    if (show === null) {
      if (show === null) {
        setshow(true);
      }
    } else {
      setshow(!show);
    }
  };

  const handleShare = (e) => {
    e.preventDefault();
    if (navigator.share) {
      navigator
        .share({
          title: item.name,
          text: item.description,
          url: window.location.href,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else {
      console.log("Web Share API is not supported in your browser.");
    }
  };

  const handleOfferClose = () => {
    setshow(false);
  };

  const increaseQuantity = () => {
    if (quantityset < item.quantity) {
      if (!item.selectedQty && item.selectedQty == 0) {
        item.selectedQty = 1;
      }
      let q = item.selectedQty + 1;
      item.selectedQty = q;
      setItem(item);
      // dispatch(handleUpdateQtyCart(item));
      setQuantityset(item.selectedQty);
      // dispatch(getTotals());
    }
  };

  const decreaseQuantity = () => {
    if (quantityset > 1) {
      setQuantityset(quantityset - 1);
      let q = item.selectedQty - 1;
      item.selectedQty = q;
      setItem(item);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(window.location.href);
    alert("Link copied to clipboard!");
  };

  const handleSwal = () => {
    Swal.fire({
      title: "Thanks for shopping with us",
      text: "Item added to cart successfully",
      icon: "success",
      showCancelButton: true,
      cancelButtonText: "Continue Shopping",
      confirmButtonColor: "#043289",
      cancelButtonColor: "#043289",
      confirmButtonText: "Go to Checkout",
    }).then((result) => {
      if (result.isConfirmed) {
        router.push("/shopping-cart");
      }
    });
  };

  const addCart = (selectedItem) => {
    dispatch(handleAddCart(selectedItem));
    dispatch(getTotals());
    handleSwal();

    if (loginData) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "USD", // replace with your currency code
          value: selectedItem.salePrice, // replace with the price of the product
          items: [
            {
              item_name: selectedItem.description,
              item_id: selectedItem.id,
              price: selectedItem.salePrice,
              item_brand: selectedItem.brandName,
              item_category: selectedItem.categoryName,
              item_list_name: "Inventory Detail Page",
              index: 0,
              quantity: selectedItem.selectedQty || 1,
            },
          ],
        },
      });
    }
  };

  const handleAddToCart = (selectedItem) => {
    addCart(selectedItem);
    fetch("/api/AddToCartNotification", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        itemName: selectedItem.description,
        clarityUserId: localStorage.getItem("clarity_user_id") || "N/A",
        name: loginData?.name || "Guest",
        qty: 1,
        userEmail: loginData?.email || "Guest",
        address: loginData?.address || "Guest",
        price: selectedItem.salePrice,
      }),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to send add-to-cart email");
        console.log("✅ Add-to-cart email sent");
      })
      .catch((err) => {
        console.error("❌ Error sending email:", err);
      });
    if (window.uetq) {
      window.uetq.push({
        ea: "AddToCart", // Event Action
        el: selectedItem.title, // Event Label (e.g., product name)
        ev: selectedItem.salePrice, // Event Value (e.g., product price)
      });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };

  function handleCallToActionClick() {
    window.location.href = "tel:830-995-5000";
  }
  function handleEmailSubmissionClickEmailUs() {
    window.location.href =
      "mailto:sales@kingsurplus.com?subject=" +
      item.title +
      " - " +
      item.assetNumber;
  }

  const getItemConditionLabel = (condition) => {
    return conditionLabels[condition] || "Used";
  };

  function setSlider() {
    if (Item?.item && Item.images.length > 0) {
      const sortedImages = Item.images.sort(
        (a, b) => a.sortOrder - b.sortOrder
      );

      return (
        <div className="product-gallery-img">
          <ImageGallery items={sortedImages} showFullscreenButton={false} />
        </div>
      );
    } else {
      return (
        <div>
          <h4>Image Not Found</h4>
        </div>
      );
    }
  }

  // Function to set up the image slider
  // const setSlider = () => {
  //   if (Item?.images && Item.images.length > 0) {
  //     // Sort images by sortOrder
  //     const sortedImages = [...Item.images].sort(
  //       (a, b) => a.sortOrder - b.sortOrder
  //     );

  //     return (
  //       <div className="product-gallery-img">
  //         <div
  //           className="position-relative main-image-wrapper rounded overflow-hidden"
  //           style={{ height: "400px" }}
  //         >
  //           <Image
  //             src={
  //               sortedImages[currentImageIndex]?.original ||
  //               "/placeholder.svg?height=600&width=600"
  //             }
  //             alt={
  //               sortedImages[currentImageIndex]?.originalAlt ||
  //               product?.item?.title ||
  //               "Product image"
  //             }
  //             fill
  //             className="object-fit-contain"
  //             priority
  //             sizes={
  //               sortedImages[currentImageIndex]?.sizes ||
  //               "(max-width: 480px) 100vw, 480px"
  //             }
  //           />

  //           {/* Navigation Arrows */}
  //           <Button
  //             variant="light"
  //             className="position-absolute start-0 top-50 translate-middle-y rounded-circle p-2 shadow-sm slider_btn"
  //             onClick={prevImage}
  //             aria-label="Previous image"
  //           >
  //             {/* <MinusIcon size={20} /> */}
  //           </Button>

  //           <Button
  //             variant="light"
  //             className="position-absolute end-0 top-50 translate-middle-y rounded-circle p-2 shadow-sm slider_btn"
  //             onClick={nextImage}
  //             aria-label="Next image"
  //           >
  //             {/* <PlusIcon size={20} /> */}
  //           </Button>
  //         </div>

  //         {/* Thumbnail Navigation */}
  //         <div
  //           className="d-flex mt-3 overflow-auto thumbnail-container"
  //           ref={thumbnailContainerRef}
  //           style={{ scrollBehavior: "smooth" }}
  //         >
  //           {sortedImages.map((image, index) => (
  //             <div
  //               key={index}
  //               className={`thumbnail-wrapper me-2 ${currentImageIndex === index ? "active-thumbnail" : ""}`}
  //               onClick={() => selectImage(index)}
  //             >
  //               <div
  //                 className="position-relative"
  //                 style={{ width: "60px", height: "60px" }}
  //               >
  //                 <Image
  //                   src={
  //                     image.thumbnail || "/placeholder.svg?height=60&width=60"
  //                   }
  //                   alt={image.thumbnailAlt || `Thumbnail ${index + 1}`}
  //                   fill
  //                   className="object-fit-cover rounded"
  //                   sizes="60px"
  //                 />
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div className="text-center p-5 bg-light rounded">
  //         <h4>Image Not Found</h4>
  //       </div>
  //     );
  //   }
  // };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  function priceValueAboveZero() {
    return item.salePrice && item.salePrice > 0 ? item.salePrice : null;
  }

  function removeSpecialCharsFromQBPaymentMethods() {
    const acc = item.paymentAccept.replace(/[\[\]"]/g, " ");
    return <h7>Payment Types Accepted : {acc && <span> {acc}</span>}</h7>;
  }

  function ReportDetailItem({ title, value }) {
    return (
      <div className="report-detail-item">
        <h4>{title}</h4>
        {N_AIfNull(value)}
      </div>
    );
  }

  function itemDescription() {
    if (!Item?.item) {
      return null;
    }

    const {
      title,
      assetNumber, //assst number
      sku,
      quantity,
      condition,
      guaranteeOrAsis,
      salePrice,
      packagingCostData,
      isLocalPickupOnly,
      isSpecializedFreightTransit,
    } = item;

    function newItemDetails() {
      let itemDescription = item.background;

      if (itemDescription) {
        return (
          <div>
            <h4 className="text_item_details">Item Description</h4>
            <p>{itemDescription}</p>
          </div>
        );
      }
    }

    function inspectionReport() {
      return (
        <div>
          <Col lg={12} className="inspection-info">
            <div className="bg-white report-info">
              <Row className="detail-container">
                <Col lg={6}>
                  <div className="report-detail-item report-detail-Header">
                    <h6>DESCRIPTION</h6>
                    <h6>DETAILS</h6>
                  </div>
                  <ReportDetailItem
                    title="Manufacturer :"
                    value={item.menufacturer}
                  />
                  <ReportDetailItem title="Serial #:" value={item.serialNo} />
                  <ReportDetailItem
                    title="HP / AMP / KW / KVA :"
                    value={item.hP_AMP_KW_KVA}
                  />
                  <ReportDetailItem
                    title="Length (Inches):"
                    value={item.lengthInches}
                  />
                  <ReportDetailItem
                    title="Estimated Packaging Weight :"
                    value={item.estiamtedPackaginWeight}
                  />
                  <ReportDetailItem
                    title="Estimated Total Weight:"
                    value={`${Number(item.estimatedTotalWeight || 0).toFixed(2)} lbs`}
                  />
                </Col>
                <Col lg={6}>
                  <div className="report-detail-item report-detail-item2 report-detail-Header">
                    <h6>DESCRIPTION</h6>
                    <h6>DETAILS</h6>
                  </div>
                  <ReportDetailItem title="Model :" value={item.model} />
                  <ReportDetailItem title="Year :" value={item.year} />
                  <ReportDetailItem title="Amps :" value={item.amps} />
                  <ReportDetailItem title="Phase :" value={item.phase} />
                  <ReportDetailItem
                    title="Width (Inches):"
                    value={item.widthInches}
                  />
                  <ReportDetailItem
                    title="Height (Inches):"
                    value={item.heightInches}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </div>
      );
    }

    useEffect(() => {
      const storedLoginData = JSON.parse(localStorage.getItem("login")) || {};
      setLoginData(storedLoginData);
    }, []);

    const handleLoginSignup = () => {
      const currentPath = router.asPath;
      router.push(`/login?redirect=${encodeURIComponent(currentPath)}`);
    };

    const saveLaterItem = (selectedItem) => {
      if (!loginData || !loginData.user) {
        handleLoginSignup();
        return;
      }

      try {
        const body = {
          id: 0,
          userId: loginData.user.id,
          ItemId: Number(selectedItem.id),
        };
        axiosClient.post("saveSaveLaterInfo", body);
        toast.success("Successfully saved for later");
      } catch (error) {
        console.error("Error:", error);
        toast.error("Failed to save for later. Please try again.");
      }
    };

    function ItemDetailsTable({ item }) {
      if (!item) return null;

      return (
        <table className="item-details-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Available Quantity</td>
              <td>{item.quantity || "N/A"}</td>
            </tr>
            <tr>
              <td>Model</td>
              <td>{item.model || "N/A"}</td>
            </tr>
            <tr>
              <td>Condition</td>
              <td>{getItemConditionLabel(item.condition)}</td>
            </tr>
            <tr>
              <td>Manufacturer</td>
              <td>{item.menufacturer || "N/A"}</td>
            </tr>
            <tr>
              <td>Asset Number</td>
              <td>{item.assetNumber || "N/A"}</td>
            </tr>
            <tr>
              <td>Guarantee or ASIS</td>
              <td>{item.guaranteeOrAsis || "N/A"}</td>
            </tr>
            <tr>
              <td>Inspections - Yellow Tag</td>
              <td>{guaranteeOrAsis && condition} </td>
            </tr>
            <tr>
              <td>Packaging Cost</td>
              <td>{packagingCostData && <span>{packagingCostData}</span>}</td>
            </tr>
          </tbody>
        </table>
      );
    }

    return (
      <Col lg={6}>
        <div className="product-gallery-info">
          <h7 className="productTitle">{item.description}</h7>
          <h1 className="hidden">{item.seoH1 ? item.seoH1 : title}</h1>
          <h2 className="hidden"> {item.seoH2 ? item.seoH2 : title}</h2>
          <h3 className="hidden"> {item.seoH3 ? item.seoH3 : title}</h3>
          <div className="desktop_price_container">
            <span>
              <h4 className="desktop_price">
                $
                {appConstants
                  .formattedValue(salePrice)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ", ")}{" "}
              </h4>
            </span>
            {/* here add the tag for locapick and specialife freight tag */}
            {item.isHotSale && <div style={{}}>{renderFrenzyAlertBadge()}</div>}
            {isLocalPickupOnly && (
              <Tag color="blue" style={{ marginBottom: 0 }}>
                Local Pickup Only
              </Tag>
            )}
            {isSpecializedFreightTransit && (
              <Tag color="blue" style={{ marginBottom: 0 }}>
                Specialized Freight Transit
              </Tag>
            )}
            {item.isFreeShipping === true && (
              <Tag color="green" style={{ marginBottom: 0 }}>
                Free Shipping
              </Tag>
            )}
          </div>

          {/* New Design */}
          <div className="stock_desktop">
            <ItemDetailsTable item={item} />
          </div>

          <div className="mobile_price_container">
            <div>
              <h4 className="productPrice">
                $
                {appConstants
                  .formattedValue(salePrice)
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
              </h4>
            </div>

            <div className="icon_container">
              <div className="mobile_saveforlater">
                <span onClick={handleShare}>
                  <FiShare2 className="share_icon" fontSize={14} />
                </span>
              </div>
              <div className="mobile_saveforlater">
                <span
                  onClick={(e) => {
                    e.preventDefault();
                    saveLaterItem(item);
                  }}
                >
                  <FaRegBookmark className="share_icon" fontSize={24} />
                </span>
              </div>
            </div>
          </div>
          <div className="mobile_qty_container">
            <Tag color="blue" style={{ marginBottom: 5 }}>
              Available Qty: {quantity}
            </Tag>
            {item.isHotSale && (
              <div style={{ marginBottom: "10px" }}>
                {renderFrenzyAlertBadge()}
              </div>
            )}
            {isLocalPickupOnly && (
              <Tag color="blue" style={{ marginBottom: 5 }}>
                Local Pickup Only
              </Tag>
            )}
            {isSpecializedFreightTransit && (
              <Tag color="blue" style={{ marginBottom: 5 }}>
                Specialized Freight Transit
              </Tag>
            )}
            {item.isFreeShipping === true && (
              <Tag color="green" style={{ marginBottom: 5 }}>
                Free Shipping
              </Tag>
            )}
          </div>

          <div className="qtyinpt-mobile">
            <div
              style={{
                display: "flex",
              }}
            >
              <Button
                type="button"
                className="qtybtn-mobile"
                onClick={decreaseQuantity}
              >
                -
              </Button>
              <Input
                className="qtyinput-mobile"
                value={quantityset}
                readOnly
                style={{
                  width: "100%",
                  textAlign: "center",
                  margin: "0 10px",
                  fontSize: "16px",
                  fontWeight: "bold",
                }}
              />
              <Button
                type="button"
                className="qtybtn-mobile"
                onClick={increaseQuantity}
              >
                +
              </Button>
            </div>
            {/* {!isSpecializedFreightTransit &&
              !isLocalPickupOnly &&
              !isFreight && (
                <div style={{ display: "flex", marginTop: 20 }}>
                  <Input
                    placeholder="Enter your ZIP code"
                    value={pinCode}
                    onChange={handlePinChange}
                    style={{ width: 340, marginRight: 8, height: 50 }}
                  />
                  <Button
                    onClick={calculateShipping}
                    loading={loading}
                    type="primary"
                    className="btn-add-to-cart"
                    style={{
                      height: 50,
                      width: 360,
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                  >
                    <Truck style={{}} /> Calculate Delivery
                  </Button>
                  
                </div>
              )} */}
          </div>
          <div className="mobile_view_product_detail">
            <div className="primary_buy_button">
              {priceValueAboveZero() && (
                <button
                  type="button"
                  onClick={(e) => {
                    buyNow(item);
                    e.preventDefault();
                  }}
                  style={{ height: 50, fontSize: 16 }}
                  className="btn btn-blue btns-33 new-btn-buy"
                >
                  <Zap style={{ margin: 5 }} /> Buy Now
                </button>
              )}
            </div>
            <div className="secondery_buy_button">
              {priceValueAboveZero() && (
                <div className="b1">
                  <button
                    onClick={(e) => {
                      handleAddToCart(item);
                      e.preventDefault();
                    }}
                    className="btn btn-blue btns-33 new-btn-cart"
                  >
                    <Icon icon="fa6-solid:cart-plus" style={{ margin: 5 }} />{" "}
                    Add To Cart
                  </button>
                  {/* <AddToCartButton item={item} selectedQty={item.selectedQty} /> */}
                </div>
              )}

              <div className="b2">
                <a
                  onClick={handleshow}
                  href="#"
                  type="button"
                  className="btn btn-blue btns-33 btn-make-an-offer"
                >
                  <CircleDollarSign style={{ margin: 5 }} /> Make an offer
                </a>
              </div>
            </div>
            {/* <SaveForLaterButton item={item} /> */}
          </div>
          <Col className="mobile_view_tab"></Col>

          <div className="desktop_view">
            <div className="qtyinpt">
              <div
                style={{
                  display: "flex",
                  gap: "14px",
                }}
              >
                <Button
                  style={{ height: 50 }}
                  className="qtybtn"
                  onClick={decreaseQuantity}
                >
                  -
                </Button>
                <Input
                  className="qtyinput"
                  value={quantityset}
                  readOnly
                  style={{
                    width: "150px",
                    height: 50,
                    textAlign: "center",
                    margin: "0 10px",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                />
                <Button
                  style={{ height: 50 }}
                  className="qtybtn"
                  onClick={increaseQuantity}
                >
                  +
                </Button>
                <div style={{ display: "flex" }}>
                  {/* {!isSpecializedFreightTransit &&
                    !isLocalPickupOnly &&
                    !isFreight && (
                      <div style={{ display: "flex" }}>
                        <Input
                          placeholder="Enter your ZIP code"
                          value={pinCode}
                          onChange={handlePinChange}
                          style={{ width: 185, marginRight: 5, height: 50 }}
                        />
                        <a
                          onClick={calculateShipping}
                          loading={loading}
                          type="primary"
                          className="btn btn-blue btns-33 btn-add-to-cart"
                          style={{ height: 50, fontSize: 16 }}
                        >
                          <Truck style={{ margin: 5 }} /> Calculate Delivery
                        </a>
                      </div>
                    )} */}
                  {/* <Modal
                    title={
                      <div>
                        <h5>Estimated Shipping Options</h5>
                        <small>
                          (Note: The displayed shipping cost is an estimate and
                          may change at checkout.)
                        </small>
                      </div>
                    }
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer={null}
                    width={900}
                    zIndex={9999999999}
                    bodyStyle={{
                      maxHeight: "600px",
                      minHeight: "200px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }} // Fixed height and scrollable content
                  >
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "40px",
                          height: "100%",
                        }}
                      >
                        <Spin size="large" />
                      </div>
                    ) : (
                      <List
                        grid={{
                          gutter: 16,
                          xs: 1, // mobile: 1 column
                          sm: 1, // small tablets: 1 column
                          md: 2, // tablets and up: 2 columns
                          lg: 2, // desktops: 2 columns
                          xl: 2,
                          xxl: 2,
                        }}
                        // grid={{ gutter: 16, column: 1 }}
                        dataSource={shippingOptions.filter(
                          (option) => !option.isInvalid
                        )}
                        renderItem={(option) => (
                          <List.Item>
                            <Card
                              title={
                                option.isInvalid
                                  ? "Invalid ZIP Code"
                                  : `${option.carrierFriendlyName || "Unknown Carrier"} - ${option.serviceType || "Unknown Service"}`
                              }
                            >
                              {option.isInvalid ? (
                                <p style={{ color: "red", fontWeight: "bold" }}>
                                  Invalid ZIP Code. Please enter a valid ZIP.
                                </p>
                              ) : option.shippingAmount ? (
                                <>
                                  <p>
                                    <strong>Cost:</strong>{" "}
                                    {option.currency
                                      ? option.currency.toUpperCase()
                                      : "USD"}{" "}
                                    $
                                    {option.shippingAmount !== null
                                      ? option.shippingAmount
                                      : "N/A"}
                                  </p>
                                  <p>
                                    <strong>Estimated Delivery:</strong>{" "}
                                    {option.estimatedDeliveryDate
                                      ? new Date(
                                          option.estimatedDeliveryDate
                                        ).toDateString()
                                      : "N/A"}
                                    ({option.deliveryDays || "N/A"} days)
                                  </p>
                                </>
                              ) : (
                                <p style={{ color: "red", fontWeight: "bold" }}>
                                  Shipping options not available.
                                </p>
                              )}
                            </Card>
                          </List.Item>
                        )}
                      />
                    )}
                  </Modal> */}

                  <Modal
                    title={
                      <div>
                        <h5>Estimated Shipping Options</h5>
                        <small>
                          (Note: The displayed shipping cost is an estimate and
                          may change at checkout.)
                        </small>
                      </div>
                    }
                    visible={isModalVisible}
                    onCancel={handleCancel}
                    footer={null}
                    width={900}
                    zIndex={9999999999}
                    bodyStyle={{
                      maxHeight: "600px",
                      minHeight: "200px",
                      overflowY: "auto",
                      overflowX: "hidden",
                    }}
                  >
                    {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          marginTop: "40px",
                          height: "100%",
                        }}
                      >
                        <Spin size="large" />
                      </div>
                    ) : (
                      // <Tabs defaultActiveKey="UPS">
                      //   {["UPS", "USPS", "FedEx"].map((carrierKey) => (
                      //     <TabPane tab={carrierKey} key={carrierKey}>
                      //       <List
                      //         grid={{
                      //           gutter: 16,
                      //           xs: 1,
                      //           sm: 1,
                      //           md: 2,
                      //           lg: 2,
                      //           xl: 2,
                      //           xxl: 2,
                      //         }}
                      //         dataSource={shippingOptions.filter(
                      //           (option) =>
                      //             (option.carrierFriendlyName || "")
                      //               .toLowerCase()
                      //               .includes(carrierKey.toLowerCase()) &&
                      //             !option.isInvalid
                      //         )}
                      //         locale={{
                      //           emptyText: `No shipping options available for ${carrierKey}`,
                      //         }}
                      //         renderItem={(option) => (
                      //           <List.Item>
                      //             <Card
                      //               title={`${option.carrierFriendlyName || "Unknown Carrier"} - ${
                      //                 option.serviceType || "Unknown Service"
                      //               }`}
                      //             >
                      //               {option.shippingAmount ? (
                      //                 <>
                      //                   <p>
                      //                     <strong>Cost:</strong>{" "}
                      //                     {option.currency
                      //                       ? option.currency.toUpperCase()
                      //                       : "USD"}{" "}
                      //                     $ {option.shippingAmount}
                      //                   </p>
                      //                   <p>
                      //                     <strong>Estimated Delivery:</strong>{" "}
                      //                     {option.estimatedDeliveryDate
                      //                       ? new Date(
                      //                           option.estimatedDeliveryDate
                      //                         ).toDateString()
                      //                       : "N/A"}{" "}
                      //                     ({option.deliveryDays || "N/A"} days)
                      //                   </p>
                      //                 </>
                      //               ) : (
                      //                 <p
                      //                   style={{
                      //                     color: "red",
                      //                     fontWeight: "bold",
                      //                   }}
                      //                 >
                      //                   Shipping options not available.
                      //                 </p>
                      //               )}
                      //             </Card>
                      //           </List.Item>
                      //         )}
                      //       />
                      //     </TabPane>
                      //   ))}
                      // </Tabs>
                      <Tabs
                        defaultActiveKey="UPS"
                        tabBarStyle={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          background: "#fff",
                          padding: "10px 0",
                          marginBottom: 16,
                          borderBottom: "1px solid #e8e8e8",
                        }}
                      >
                        {["UPS", "USPS", "FedEx"].map((carrierKey) => (
                          <TabPane tab={carrierKey} key={carrierKey}>
                            <List
                              grid={{
                                gutter: 16,
                                xs: 1,
                                sm: 1,
                                md: 2,
                                lg: 2,
                                xl: 2,
                                xxl: 2,
                              }}
                              dataSource={shippingOptions
                                .filter(
                                  (option) =>
                                    (option.carrierFriendlyName || "")
                                      .toLowerCase()
                                      .includes(carrierKey.toLowerCase()) &&
                                    !option.isInvalid
                                )
                                .sort(
                                  (a, b) =>
                                    (a.shippingAmount || 0) -
                                    (b.shippingAmount || 0)
                                )} // sort low to high
                              locale={{
                                emptyText: `No shipping options available for ${carrierKey}`,
                              }}
                              renderItem={(option) => (
                                <List.Item>
                                  <Card
                                    title={`${option.carrierFriendlyName || "Unknown Carrier"} - ${
                                      option.serviceType || "Unknown Service"
                                    }`}
                                  >
                                    {option.shippingAmount ? (
                                      <>
                                        <p>
                                          <strong>Cost:</strong>{" "}
                                          {option.currency
                                            ? option.currency.toUpperCase()
                                            : "USD"}{" "}
                                          ${option.shippingAmount}
                                        </p>
                                        <p>
                                          <strong>Estimated Delivery:</strong>{" "}
                                          {option.estimatedDeliveryDate
                                            ? new Date(
                                                option.estimatedDeliveryDate
                                              ).toDateString()
                                            : "N/A"}{" "}
                                          ({option.deliveryDays || "N/A"} days)
                                        </p>
                                      </>
                                    ) : (
                                      <p
                                        style={{
                                          color: "red",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Shipping options not available.
                                      </p>
                                    )}
                                  </Card>
                                </List.Item>
                              )}
                            />
                          </TabPane>
                        ))}
                      </Tabs>
                    )}
                  </Modal>
                </div>
              </div>
            </div>

            <div className="btns-wrap btns-33Wrap desktop_button_view">
              {priceValueAboveZero() && (
                <>
                  <Button
                    type="button"
                    style={{ height: 60 }}
                    onClick={(e) => {
                      buyNow(item);
                      e.preventDefault();
                    }}
                    className="btn btn-blue btns-33 new-btn-buy"
                  >
                    <Zap style={{ margin: 5 }} /> Buy Now
                  </Button>

                  <Button
                    onClick={(e) => {
                      handleAddToCart(item);
                      e.preventDefault();
                    }}
                    className="btn btn-blue btns-33 new-btn-cart"
                    style={{ height: 60, fontSize: 16 }}
                  >
                    <ShoppingCart style={{ margin: 5 }} /> Add To Cart
                  </Button>
                </>
              )}

              <a
                onClick={handleshow}
                href="#"
                type="button"
                className="btn btn-blue btns-33 btn-add-to-cart"
                style={{ height: 60, fontSize: 16 }}
              >
                <CircleDollarSign style={{ margin: 5 }} /> Make an offer
              </a>

              <div className=" btns-33 btn-save">
                <SaveForLaterButton item={item} />
              </div>
              <button
                href="tel:830-995-5000"
                className="call-us btns-33"
                style={{ height: 60, fontSize: 16, borderRadius: "5px" }}
                onClick={handleCallToActionClick}
              >
                <Phone style={{ margin: 5 }} />
                Call Us
              </button>
              <button
                href={
                  "mailto:sales@kingsurplus.com?subject=" +
                  item.title +
                  " - " +
                  item.assetNumber
                }
                className="email-us"
                style={{ height: 60, fontSize: 16, borderRadius: "5px" }}
                onClick={handleEmailSubmissionClickEmailUs}
              >
                <Mail style={{ margin: 5 }} />
                Email Us
              </button>
            </div>
          </div>
        </div>
      </Col>
    );
  }

  function N_AIfNull(val) {
    if (!val || val.toString() === "[]" || val.toString() === "0") {
      return <span>N/A</span>;
    } else {
      return <p>{val}</p>;
    }
  }
  function ReportDetailItem({ title, value }) {
    return (
      <div className="report-detail-item">
        <p>{title}</p>
        <p>{N_AIfNull(value)}</p>
      </div>
    );
  }

  function inspectionReport() {
    if (!Item || !Item.item) {
      return null;
    }

    const { item } = Item;
    const { background, factoryInformationOnly } = item;

    let modifiedBackground = background
      ? background
          .replace(/<\s*h1\s*>/gi, "<p>")
          .replace(/<\/\s*h1\s*>/gi, "</p>")
      : "";

    return (
      <div className="inspection-info">
        {/* <div className="mobile-product-detail-card mt-3">
          <h3 className="mt-2 card-title">Basic Information</h3>
          <hr />
          <Row>
            <Col lg={6}>
              <h5 className="">
                Asset # : <span>{item.assetNumber}</span>{" "}
              </h5>
            </Col>
            <Col lg={6}>
              <h5 className="">
                Available Qty: <span>{item.quantity}</span>
              </h5>
            </Col>
            <Col lg={6}>
              <h5 className="">
                Inspections - Yellow Tag :{" "}
                <span> {item.guaranteeOrAsis && item.condition} </span>
              </h5>
            </Col>
            <Col lg={6}>
              <h5 className="">
                Condition :{" "}
                <span> {getItemConditionLabel(item.condition)} </span>
              </h5>
            </Col>
          </Row>

          <h5>
            Guarantee or ASIS :{" "}
            <span>{item.guaranteeOrAsis && item.guaranteeOrAsis}</span>{" "}
          </h5>
        </div> */}
        <div className="mobile-product-detail-card mt-4 p-3 rounded shadow-sm bg-white">
          <h3 className="mb-3 fw-bold  card-title">Basic Information</h3>
          <hr className="mb-4" />

          <Row className="gy-3">
            <Col lg={6}>
              <div>
                <p className="mb-1 text-muted small">Asset #</p>
                <p className="fw-semibold text-dark">
                  {item.assetNumber || "N/A"}
                </p>
              </div>
            </Col>

            <Col lg={6}>
              <div>
                <p className="mb-1 text-muted small">Available Quantity</p>
                <p className="fw-semibold text-dark">
                  {item.quantity || "N/A"}
                </p>
              </div>
            </Col>

            <Col lg={6}>
              <div>
                <p className="mb-1 text-muted small">
                  Inspections - Yellow Tag
                </p>
                <p className="fw-semibold text-dark">
                  {item.guaranteeOrAsis && item.condition
                    ? item.condition
                    : "N/A"}
                </p>
              </div>
            </Col>

            <Col lg={6}>
              <div>
                <p className="mb-1 text-muted small">Condition</p>
                <p className="fw-semibold text-dark">
                  {getItemConditionLabel(item.condition) || "N/A"}
                </p>
              </div>
            </Col>
          </Row>

          <div className="mt-4">
            <p className="mb-1 text-muted small">Guarantee or ASIS</p>
            <p className="fw-semibold text-dark">
              {item.guaranteeOrAsis || "N/A"}
            </p>
          </div>
        </div>

        {item.background && (
          <Container fluid className="specifications-section">
            <h3 className="mt-2 card-title">Item Description</h3>
            <hr />
            {/* <h4 className="specifications-title">Item Description</h4> */}
            <div className="spec-table-block bg-white p-2 rounded-3 text-black ">
              <Row>
                <Col lg={12}>
                  {item.background ? (
                    <div
                      className=""
                      dangerouslySetInnerHTML={{
                        __html: item.background,
                      }}
                    />
                  ) : (
                    <p>No additional item description available.</p>
                  )}
                </Col>
              </Row>
            </div>
          </Container>
        )}
        {factoryInformationOnly && (
          <Col lg={12}>
            <div className=" report-info report-info2 mt-3 specifications-section">
              <h3 className="mt-2 card-title">Factory Information</h3>
              <hr />
              <Row>
                <Col lg={12}>
                  <div className="report-detail-item">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: factoryInformationOnly,
                      }}
                    ></div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        )}

        <Row>
          <Col lg={12}>
            <div>
              <Container className="pt-4 pb-1 bg-white rounded-3 specification-card">
                {/* Specifications Section */}
                <div className="mb-5">
                  <h3 className="d-flex align-items-left gap-2 mb-4">
                    <FileText className="text-error" size={30} />
                    Specifications
                  </h3>
                  <Row className="g-4">
                    {productSpecifications.map((spec, index) => (
                      <Col key={index} xs={12} md={6} lg={4}>
                        <div className="p-4 bg-light rounded-3">
                          <div className="text-bold mb-2 ">{spec.label}</div>
                          <div className="h5 mb-0">
                            <strong>{spec.value}</strong>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </Container>
            </div>
          </Col>
        </Row>

        {priceValueAboveZero() && (
          <>
            <Col className=" p-3 mt-4 rounded shadow-sm bg-white">
              <div>
                <h3 className="fw-bold card-title">Packaging fees</h3>
                <Row className="">
                  <Col lg={6}>
                    <div>
                      <p className="mb-1 text-muted small">Packaging Cost</p>
                      <p className="fw-semibold text-dark">
                        {item.packagingCostData || "N/A"}
                      </p>
                    </div>
                  </Col>

                  {item.isLocalPickupOnly && (
                    <Col lg={6}>
                      <div>
                        <p className="mb-1 text-muted small">Pickup Only</p>
                        <p className="fw-semibold text-dark">Yes</p>
                      </div>
                    </Col>
                  )}

                  {item.isSpecializedFreightTransit === true && (
                    <Col lg={6}>
                      <div>
                        <p className="mb-1 text-muted small">
                          Specialized Freight Transit
                        </p>
                        <p className="fw-semibold text-dark">Yes</p>
                      </div>
                    </Col>
                  )}
                </Row>
              </div>
            </Col>
            <Col className=" p-3 mt-4 rounded shadow-sm bg-white">
              <div className="mb-4">
                <h3 className="fw-bold card-title mb-3">Payment Details</h3>

                <Row className="gy-3">
                  <Col lg={6}>
                    <div>
                      <p className="mb-1 text-muted small">Appraised Value</p>
                      <p className="fw-semibold text-dark">
                        $
                        {appConstants
                          .formattedValue(item.salePrice)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      </p>
                    </div>
                    <div>
                      <p className="mb-1 text-muted small">Payment Methods</p>
                      <p className="fw-semibold text-dark">
                        {removeSpecialCharsFromQBPaymentMethods()}
                      </p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </>
        )}

        {show !== null && item && (
          <Suspense fallback={<div>Loading...</div>}>
            <MakeOffer item={item} close={handleOfferClose} show={show} />
          </Suspense>
        )}
      </div>
    );
  }

  let modifiedBackground2 = item.background
    ? item.background.replace(/<\s*h1\s*>/gi, "").replace(/<\/\s*h1\s*>/gi, "")
    : "";

  return (
    <>
      <Header />
      <Head>
        <link rel="preload" href={Item.images[0]?.original} as="image" />
        <title>{item.seoTitle ? item.seoTitle : item.description}</title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
        <meta
          name="description"
          content={item.seoDescription ? item.seoDescription : item.background}
        />
        <meta
          property="og:title"
          content={item.seoTitle ? item.seoTitle : item.description}
        />
        <meta
          property="og:description"
          content={item.seoDescription ? item.seoDescription : item.background}
        />
        <meta
          property="og:url"
          content={`https://kingsurplus.com${item.productSlug}`}
        />
        <meta
          property="og:image"
          content={
            Item.images && Item.images[0] ? Item.images[0].original : null
          }
        />
        <meta property="og:type" content="product" />
        <meta property="og:brand" content={item.menufacturer} />
        <meta
          property="og:product:retailer_part_no"
          content={item.model ? item.model.toString().replace(/"/g, " ") : ""}
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            item.seoTitle
              ? item.seoTitle.toString().replace(/"/g, " ")
              : item.description
          }
        />
        <meta
          name="twitter:description"
          content={
            item.seoDescription
              ? item.seoDescription.toString().replace(/"/g, " ")
              : item.background
          }
        />
        <meta
          name="twitter:image"
          content={
            Item.images && Item.images[0] ? Item.images[0].original : null
          }
        />
        <meta
          name="twitter:url"
          content={`https://kingsurplus.com${item.productSlug}`}
        />

        <link
          rel="canonical"
          href={`https://kingsurplus.com${item.productSlug}`}
        />

        <script type="application/ld+json">
          {`
  {
    "@context": "http://schema.org",
    "@type": "Product",
    "productID": "${item.assetNumber}",
    "name": "${item.title ? item.title.toString().replace(/"/g, " ") : ""}",
    "description": "${
      item.seoDescription
        ? item.seoDescription.toString().replace(/"/g, " ")
        : item.background
    }",
    "brand": {
      "@type": "Brand",
      "name": "${item.menufacturer}"
    },
    "mpn": "${item.model ? item.model.toString().replace(/"/g, " ") : ""}",
    "offers": {
      "@type": "Offer",
      "price": "${item.salePrice}", 
      "priceCurrency": "USD",
      "availability": "http://schema.org/InStock",
      "itemCondition": "https://schema.org/${getJsonLdConditionLabel(
        item.condition
      )}",
      "url": "https://kingsurplus.com${item.productSlug}",
      "seller": {
        "@type": "Organization",
        "name": "King Surplus",
        "url": "https://kingsurplus.com",
        "contactPoint": {
          "@type": "ContactPoint",
          "telephone": "+1-830-995-5000",
          "contactType": "Customer Service"
        }
      },
      "hasMerchantReturnPolicy": {
        "@type": "MerchantReturnPolicy",
        "applicableCountry": "US",
        "returnPolicyCategory": "http://schema.org/MerchantReturnFiniteReturnWindow",
        "merchantReturnDays": 14,
        "returnMethod": "http://schema.org/ReturnByMail",
        "returnFees": "http://schema.org/FreeReturn"
      },
      "priceValidUntil": "2050-12-31",
      "shippingDetails": {
        "@type": "OfferShippingDetails",
        "deliveryTime": {
          "@type": "ShippingDeliveryTime",
          "handlingTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 1,
            "unitCode": "DAY"
          },
          "transitTime": {
            "@type": "QuantitativeValue",
            "minValue": 1,
            "maxValue": 5,
            "unitCode": "DAY"
          }
        },
        "shippingDestination": {
          "@type": "DefinedRegion",
          "addressCountry": "US"
        },
        "shippingRate": {
          "@type": "MonetaryAmount",
          "currency": "USD",
          "value": "0.00"
        },
        "shippingRateNote": "Calculated At Checkout",
        "shippingWeight": {
        "@type": "QuantitativeValue",
        "value": ${item.estimatedTotalWeight}, 
        "unitCode": "LB" 
         },
        "height": {
          "@type": "QuantitativeValue",
          "value": "${item.heightInches}",
          "unitCode": "IN"
        },
        "width": {
          "@type": "QuantitativeValue",
          "value": "${item.widthInches}",
          "unitCode": "IN"
        },
        "depth": {
          "@type": "QuantitativeValue",
          "value": "${item.lengthInches}",
          "unitCode": "IN"
        }
      }
    },
    "image": "${
      Item.images && Item.images[0] ? Item.images[0].original : null
    }",
    "additionalProperty": [
      {
        "@type": "PropertyValue",
        "name": "Inspections",
        "value": "${item.guaranteeOrAsis && item.condition}"
      },
      {
        "@type": "PropertyValue",
        "name": "Offer",
        "value": "${appConstants.formattedValue(item.salePrice)}"
      },
      {
        "@type": "PropertyValue",
        "name": "Appraised Value",
        "value": "${appConstants.formattedValue(item.salePrice)}"
      },
      {
        "@type": "PropertyValue",
        "name": "Manufacturer",
        "value": "${item.menufacturer}"
      },
      {
        "@type": "PropertyValue",
        "name": "Model",
        "value": "${item.model ? item.model.toString().replace(/"/g, " ") : ""}"
      },
      {
        "@type": "PropertyValue",
        "name": "Amps",
        "value": "${item.amps}"
      },
      {
        "@type": "PropertyValue",
        "name": "Voltage",
        "value": ${item.voltage ? JSON.stringify(item.voltage) : '"N/A"'}

      },
      {
        "@type": "PropertyValue",
        "name": "Phase",
        "value": "${item.phase}"
      },
      {
        "@type": "PropertyValue",
        "name": "HP / AMP / KW / KVA",
        "value": "${item.hP_AMP_KW_KVA}"
      },
      {
        "@type": "PropertyValue",
        "name": "Image",
        "value": "${
          Item.images && Item.images[0] ? Item.images[0].original : null
        }"
      }
    ]
  }
  `}
        </script>
      </Head>
      <div className="wrapper">
        {Item && item && item.id > 0 && (
          <div className="d-margin-top">
            <Container>
              <Breadcrumb>
                <Breadcrumb.Item href="https://kingsurplus.com" title="Home">
                  Home
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  href={`https://kingsurplus.com/${Item?.item?.industrySlug}`}
                  title={Item?.item?.industryName}
                >
                  {Item?.item?.industryName}
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  href={`https://kingsurplus.com/category/${Item?.item?.categorySlug}`}
                  title={Item?.item?.categoryName}
                >
                  {Item?.item?.categoryName}
                </Breadcrumb.Item>
                {Item?.item?.typeName && (
                  <Breadcrumb.Item
                    href={`https://kingsurplus.com/type/${Item?.item?.typeSlug}`}
                    title={Item?.item?.typeName}
                  >
                    {Item?.item?.typeName}
                  </Breadcrumb.Item>
                )}
                <Breadcrumb.Item active>
                  <Tooltip title={Item?.item?.title} placement="top">
                    <span
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "250px", // Adjust the width as needed
                        display: "inline-block",
                      }}
                    >
                      {Item?.item?.title}
                    </span>
                  </Tooltip>
                </Breadcrumb.Item>
              </Breadcrumb>

              <Row>
                <Col lg={6} className="mb-4">
                  <div>
                    {setSlider()}
                    {/* Product Images */}
                  </div>
                </Col>
                {itemDescription()}
              </Row>

              {inspectionReport()}

              {Item.categoryItems && Item.categoryItems.length > 0 && (
                <div className="similar-product mt-5">
                  <h4>Similar Items You Might Interested In</h4>
                  <Row>
                    {Item.categoryItems.map((product) => (
                      <Col
                        key={product.id}
                        xl={3}
                        lg={4}
                        md={6}
                        onClick={scrollToTop}
                      >
                        <ProductCard key={product.id} productDetail={product} />
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
            </Container>
          </div>
        )}
      </div>
      <Footer className="footer-container" />
    </>
  );
}
